import { Module } from '@nestjs/common';
import { ExcelUploadService } from './excel-upload.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ExcelUploadController } from './excel-upload.controller';
import { DrrExcel } from './entities/drrexcel.entity';
import { LedgerExcel } from './entities/ledgerexcel.entity';



@Module({
  imports: [
    TypeOrmModule.forFeature([LedgerExcel, DrrExcel])
  ],
  controllers: [ExcelUploadController],
  providers: [ExcelUploadService],
  exports: [ExcelUploadService]
})
export class ExcelUploadModule { }
